import { jsx as _jsx } from "react/jsx-runtime";
import { SearchResultsContext } from "@/contexts";
import { setJobTypeSuids } from "@/jobTypeSuids";
import { SearchParamType } from "@/types/SearchParamType";
import { useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { JobFilterMultiSelect } from "@/components/cortex/components/SearchForm/JobFilterMultiSelect";
import { SearchFormContext } from "@/components/cortex/components/SearchForm/SearchFormContext";
function useReconcileJobTypeSuids() {
    var _a = useContext(SearchResultsContext), searchData = _a.searchData, filterOptionsLoading = _a.filterOptionsLoading;
    var _b = useContext(SearchFormContext), jobTypeSuidValues = _b.jobTypeSuidValues, setJobTypeSuidValues = _b.setJobTypeSuidValues;
    var _c = useSearchParams(), searchParams = _c[0], setSearchParams = _c[1];
    useEffect(function () {
        if (filterOptionsLoading || searchData === null) {
            return;
        }
        var availableSuids = new Set(searchData.filterOptions.jobTypes.map(function (option) { return option.value; }));
        var validSelections = jobTypeSuidValues.filter(function (value) {
            return availableSuids.has(value);
        });
        if (validSelections.length === jobTypeSuidValues.length) {
            return;
        }
        setJobTypeSuidValues(validSelections);
        var updatedParams = new URLSearchParams(searchParams);
        setJobTypeSuids(updatedParams, validSelections);
        updatedParams.delete(SearchParamType.CURSOR);
        updatedParams.delete(SearchParamType.JOB_KEY);
        setSearchParams(updatedParams, { replace: true });
    }, [
        filterOptionsLoading,
        jobTypeSuidValues,
        searchData,
        searchParams,
        setJobTypeSuidValues,
        setSearchParams,
    ]);
}
export function JobTypeMultiSelect() {
    var _a;
    var _b = useContext(SearchResultsContext), searchData = _b.searchData, filterOptionsLoading = _b.filterOptionsLoading;
    var _c = useContext(SearchFormContext), jobTypeSuidParamKey = _c.jobTypeSuidParamKey, jobTypeSuidValues = _c.jobTypeSuidValues, setJobTypeSuidValues = _c.setJobTypeSuidValues;
    useReconcileJobTypeSuids();
    return (_jsx(JobFilterMultiSelect, { label: "Job types", name: jobTypeSuidParamKey, options: (_a = searchData === null || searchData === void 0 ? void 0 : searchData.filterOptions.jobTypes) !== null && _a !== void 0 ? _a : [], value: jobTypeSuidValues, onValueChange: setJobTypeSuidValues, loading: filterOptionsLoading, placeholder: "Job types", emptyText: "No job types found" }));
}
